import { sha1 } from 'object-hash';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkEstimationExists } from '../../../actions/checkEstimationExists';
import { checkEstimationForUser } from '../../../actions/checkEstimationExists/checkEstimationForUser';
import { openDataPaymentForm } from '../../../actions/dataPayment';
import { getEstimationSuccess } from '../../../actions/estimation';
import { selectCheckEstimationExists } from '../../../selectors/checkEstimationExists/selectCheckEstimationExists';
import { selectApiParameters } from '../../../selectors/estimation';
import { selectDealType } from '../../../selectors/page';
import { TThunkDispatch } from '../../../types/redux';

/**
 * Если нет id оценки:
 *  - проверяем есть ли у нас оценка по заданному адресу
 *  - если оценка есть, проверяем оценивал ли пользователь этот объект ранее
 *    - если оценивал - покажем плашку "Кажется вы уже оценивали этот объект"
 *    - если не оценивал - ведем в форму расплаты за оценку
 * Если id оценки есть и все равно нажал "Далее" - ведем в форму расплаты за оценку
 */
export function useHandleDatapaymentSubmit() {
  const { estimationId } = useSelector(selectCheckEstimationExists);
  const dispatch = useDispatch<TThunkDispatch>();
  const requestParams = useSelector(selectApiParameters);
  const dealType = useSelector(selectDealType);

  return React.useCallback(async () => {
    if (!estimationId) {
      const isEstimationExists = await dispatch(checkEstimationExists());

      if (isEstimationExists) {
        const result = await dispatch(checkEstimationForUser());

        if (!result) {
          dispatch(openDataPaymentForm());
        }
      }

      const filtersHash = sha1(requestParams);
      dispatch(
        getEstimationSuccess({
          data: null,
          filtersHash,
          dealType,
        }),
      );

      return;
    }

    dispatch(openDataPaymentForm());
  }, [dealType, dispatch, estimationId, requestParams]);
}
